module.exports = __webpack_public_path__ + "static/media/CompleteCompliance.62b3d5ff.svg";